// src/InlineSpinner.tsx
import { jsx } from "react/jsx-runtime";
var SIZE_MAP = {
  xs: "w-3.5 h-3.5 border-[1.5px]",
  sm: "w-4 h-4 border-2",
  md: "w-5 h-5 border-2",
  lg: "w-8 h-8 border-2"
};
var InlineSpinner = ({ size = "sm", className = "" }) => /* @__PURE__ */ jsx(
  "div",
  {
    className: `rounded-full animate-spin border-current border-t-transparent ${SIZE_MAP[size] || SIZE_MAP.sm} ${className}`,
    role: "status",
    "aria-label": "Loading"
  }
);
var InlineSpinner_default = InlineSpinner;

export {
  InlineSpinner_default
};
